<template>
  <div class="white p-4 rounded">
    <h3>{{ $t('first-run.no-company.heading') }}</h3>
    <p>{{ $t('first-run.no-company.text') }}</p>
    <router-link :to="{name:'firstrun'}">
      <button type="button" class="btn btn-primary">
        {{ $t('first-run.no-company.btn') }}
      </button>
    </router-link>
  </div>
</template>

<script>
export default {
    name: 'NoCompany',
}
</script>
